﻿import React from 'react';
import {Collapse, CollapseProps} from "@mui/material";
import {styled} from "@mui/material/styles";

const Root = styled(Collapse)(({theme}) => ({
  backgroundColor: '#fff',
  marginTop: theme.spacing(1),
  borderRadius: theme.spacing(1),
  minWidth: '100%',
  overflowX: 'auto',
}));

type CollapsableCardCollapseContainerProps = Omit<CollapseProps, 'ref'>;

/**
 * MUI Collapse component styled in the SecurSpace way with default features enabled. Used after the clickable header section of the collapsable card
 * @param [unmountOnExit=true] {@link CollapseProps.unmountOnExit} set to `true` by default which unmounts the children when the collapse is not expanded.
 * @param [timeout='auto'] {@link CollapseProps.timeout} set to 'auto' by default which automatically calculates the transition time based on height.
 * @param children children passed through to the internal Collapse component
 * @param rest The rest of the Collapse props that will be passed through to the internal Collapse component
 *
 * @see {@link Collapse} for MUI documentation
 */
const CollapsableCardCollapseContainer = (
  {timeout = 'auto', unmountOnExit = true, children, ...rest}: CollapsableCardCollapseContainerProps) => {
  return <Root timeout={timeout} unmountOnExit={unmountOnExit} {...rest}>
    {children}
  </Root>
}

export { CollapsableCardCollapseContainer };